export function stripHtmlTags(html: string | undefined | null): string {
  if (html == null) return ''

  const source = typeof html === 'string' ? html : String(html)
  if (!source.trim()) return ''

  const doc = new DOMParser().parseFromString(source, 'text/html')
  const text = doc.body.textContent ?? ''

  return text.replace(/\s+/g, ' ').trim()
}

export function hasPlainDescription(html: string | undefined | null): boolean {
  return stripHtmlTags(html).length > 0
}

export function getPlainDescription(html: string | undefined | null): string | undefined {
  const plain = stripHtmlTags(html)
  return plain || undefined
}
